<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='财务+更多信息'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='500'
      >
      <template v-slot:content>
        <v-tabs v-model="tab" class="ml-6">
          <v-tab>更多信息</v-tab>
          <v-tab>财务信息</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <detail-view ref='detail' :item='item' @on-load-data='loadData' :show="item.show"></detail-view>
          </v-tab-item>
          <v-tab-item>
            <finace-view ref='finace' :item='item' @on-load-data='loadData' :show="item.show"></finace-view>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import FinaceView from './Finance.vue'
  import DetailView from './Detail.vue'

  export default {
    name: 'CustomerMore',
    components: {
      FinaceView,
      DetailView
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        tab: 0
      }
    },
    methods: {
      dialogChange (val) {
        this.item.show = val
        this.tab = 0
      },
      loadData() {
        this.$emit("on-load-data")
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
